export default __webpack_public_path__ + "static/media/mask.bfaefefd.png";